import { PERMISSIONS } from 'features/ezlogicUserPermissions';
import { AddButton as EzloPluginsAddButton } from 'containers/Ezlo/EzloPlugins/components/AddButton';
import { Upgrade } from 'assets/icons';
import { CreateNotificationTemplateButton } from 'containers/Ezlo/EzloOEMNotifications';
import DeviceSettings from 'components/DeviceCard/components/DeviceSettings';
import { CreateBackupButton } from 'containers/Ezlo/EzloHubBackups/CreateBackupButton';
import { RestoreBackupButton } from 'containers/Ezlo/EzloHubBackups/RestoreBackupButton';
import { VirtualDeviceActions } from 'containers/Ezlo/EzloVirtualContainer/VirtualDevicesList/VirtualDeviceItem/VirtualDeviceActions';
import { CreateContainerButton } from 'containers/Ezlo/EzloVirtualContainer/CreateContainerButton';
import ExpressionItemActions from 'containers/Ezlo/EzloExpressions/ExpressionItem/ExpressionItemInfo/ExpressionItemActions';

/**
 * Configuration object for enhancing UI components with permission checks and other behaviors.
 *
 * Each entry defines the original (raw) component and the required permission needed to render or use it.
 * This config can be used in a builder or factory to automatically wrap each component with permission guards
 * or any additional logic (e.g., error boundaries, feature toggles).
 *
 * @typedef {Object} ComponentConfig
 * @property {React.ComponentType} component - The raw React component to be enhanced.
 * @property {string} requiredPermission - The permission key required for this component to be accessible.
 *
 * @type {Object.<string, ComponentConfig>}
 *
 * @example
 * // Usage:
 * import { componentsConfig } from './componentsConfig';
 * const { component, requiredPermission } = componentsConfig.EzloPluginsAddButton;
 * // ...wrap with permission HOC, etc.
 */
export const componentsConfig = {
    EzloPluginsAddButton: {
        component: EzloPluginsAddButton,
        requiredPermission: PERMISSIONS.MANAGE_PLUGINS,
    },
    UpgradePluginIcon: {
        component: Upgrade,
        requiredPermission: PERMISSIONS.MANAGE_PLUGINS,
    },
    CreateNotificationTemplateButton: {
        component: CreateNotificationTemplateButton,
        requiredPermission: PERMISSIONS.MANAGE_NOTIFICATIONS_TEMPLATES,
    },
    DeviceSettings: {
        component: DeviceSettings,
        requiredPermission: PERMISSIONS.MANAGE_DEVICE_SETTINGS,
    },
    CreateBackupButton: {
        component: CreateBackupButton,
        requiredPermission: PERMISSIONS.MANAGE_BACKUPS,
    },
    RestoreBackupButton: {
        component: RestoreBackupButton,
        requiredPermission: PERMISSIONS.MANAGE_BACKUPS,
    },
    VirtualDeviceActions: {
        component: VirtualDeviceActions,
        requiredPermission: PERMISSIONS.MANAGE_VIRTUAL_CONTAINER,
    },
    CreateContainerButton: {
        component: CreateContainerButton,
        requiredPermission: PERMISSIONS.MANAGE_VIRTUAL_CONTAINER,
    },
    ExpressionItemActions: {
        component: ExpressionItemActions,
        requiredPermission: PERMISSIONS.MANAGE_VARIABLES_EXPRESSIONS,
    },
};
